function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.875 21.538c0 1.36-1.063 2.462-2.375 2.462s-2.375-1.102-2.375-2.462zM9.5 0c.986 0 1.781.825 1.781 1.846v.837c3.402.837 5.344 3.994 5.344 7.779v6.153L19 19.077v1.23H0v-1.23l2.375-2.462v-6.153c0-3.785 1.942-6.942 5.344-7.779v-.837C7.719.825 8.514 0 9.5 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgNotifIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    color: "currentColor"
  }, props), _ref);
}

export default SvgNotifIcon;